export const COOKIE_CONSENT_AGREED_NAME = 'consent-agreed';
export const COOKIE_NAME_LIST = [
  '_gat_UA-5303491-1',
  '_ga',
  '_gid',
  '_fbp',
  'alphachat-active-session',
  'alphachat-test',
  'alphachat-enduser-token',
  'alphachat-user-data',
];

export const COOKIE_CONSENT_EXPIRATION_MS =
  Date.now() + 100 * 24 * 60 * 60 * 1000;

export const CookieConsentValue = {
  accept: 'true',
  reject: 'false',
};

const developmentCookieOptions = {
  path: '/',
};

const productionCookieOptions = {
  path: '/',
  domain: '.stat.ee',
};

export const cookieOptions =
  process.env.NODE_ENV === 'production'
    ? productionCookieOptions
    : developmentCookieOptions;

export const addCookieScript = () => {
  // TODO: add cookie scripts here once added to the app
};

export const removeCookieScript = () => {
  // TODO: remove added cookie scripts here
};
